import {
	useBasePriceText,
	usePriceScreenReaderTextGetter,
} from 'components/Price';
import { useProductTagsScreenReaderTextGetter } from 'components/ProductTag';
import { useRatingScreenReaderTextGetter } from 'components/Rating';
import type { ProductPrice } from 'models/price';
import type { ProductTag } from 'models/product';

export function useProductCardScreenReaderText({
	basePrice,
	checklist,
	customisableUspTag,
	flag,
	heading,
	multipleVariantIndicatorText,
	price,
	reviewCount,
	score = 0,
	srSubheading,
	subheading,
	tags,
	vatPriceText,
}: {
	basePrice: ProductPrice | undefined;
	checklist?: string[];
	customisableUspTag?: ProductTag;
	flag: ProductTag | undefined;
	heading: string | undefined;
	multipleVariantIndicatorText?: string;
	price: ProductPrice | undefined;
	reviewCount: number | undefined;
	score: number | undefined;
	srSubheading: string | undefined;
	subheading: string | undefined;
	tags: ProductTag[] | undefined;
	vatPriceText: string | undefined;
}): string {
	const basePriceText = useBasePriceText({
		basePrice,
		displayedPriceType: price?.priceType,
		recentLowestPriceKey: 'product_list_recent_lowest_price_text',
	});
	const getPriceScreenReaderText = usePriceScreenReaderTextGetter();
	const getRatingScreenReaderText = useRatingScreenReaderTextGetter();
	const getTagsScreenReaderText = useProductTagsScreenReaderTextGetter();

	return [
		heading,
		srSubheading || subheading,
		price && getPriceScreenReaderText({ price }),
		vatPriceText,
		basePriceText?.srLabel || basePriceText?.text,
		flag?.text,
		tags && getTagsScreenReaderText(tags),
		score > 0 && getRatingScreenReaderText({ score, reviewCount }),
		customisableUspTag?.text,
		checklist?.join(', '),
		multipleVariantIndicatorText,
	]
		.filter(Boolean)
		.join(', ');
}
